/**
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const NatCal = require('../types/NatCal')
const CValDyn = require('./CValDyn')
const CCalculAncetre = require('./CCalculAncetre')

module.exports = CAbscisseOrigineRep

/**
 * Objet représentant l'abscisse à l'origine d'un repère
 * @constructor
 * @extends CCalculAncetre
 * @param {CListeObjets} listeProprietaire : la liste propriétaire
 * @param {CImplementationProt} impProto : L'implémentation de construction propriétaire (peut être null)
 * @param {boolean} estElementFinal : true si l'objet est un objet final de construction
 * @param {String} nomCalcul : Le nom du calcul représentant cette abscisse à l'origine
 * @param {Crepere} rep : Pointe sur le repère associé
 * @returns {undefined}
 */
function CAbscisseOrigineRep (listeProprietaire, impProto, estElementFinal, nomCalcul, rep) {
  if (arguments.length === 0) return // Ajout version WebPack
  if (arguments.length === 1) CValDyn.call(this, listeProprietaire);
  else {
    CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
    this.rep = rep;
    this.abscisseOrigine = 0;
  }
}
CAbscisseOrigineRep.prototype = new CCalculAncetre();
CAbscisseOrigineRep.prototype.constructor = CAbscisseOrigineRep;
CAbscisseOrigineRep.prototype.superClass = "CCalculAncetre";
CAbscisseOrigineRep.prototype.className = "CAbscisseOrigineRep";

/** inheritDoc */
CAbscisseOrigineRep.prototype.getClone = function(listeSource, listeCible) {
  var ind1 = listeSource.indexOf(this.rep);
  var ind2 = listeSource.indexOf(this.impProto);
  return new CAbscisseOrigineRep(listeCible, listeCible.get(ind2, "CImplementationProto"),
    this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CRepere"));
};

CAbscisseOrigineRep.prototype.getNatureCalcul = function() {
  return NatCal.NAbscisseOrigineRep;
};

CAbscisseOrigineRep.prototype.setClone = function(ptel) {
  this.abscisseOrigine = ptel.abscisseOrigine;
};

CAbscisseOrigineRep.prototype.ajouteAntecedents = function(liste) {
  liste.add(this.rep.o);
  liste.add(this.rep.i);
  liste.add(this.rep.j);
};

CAbscisseOrigineRep.prototype.depDe = function(p) {
  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
  return this.memDep(CCalculAncetre.prototype.depDe.call(this, p) || this.rep.depDe(p));
};

CAbscisseOrigineRep.prototype.dependDePourBoucle = function(p) {
  return (p === this) || this.rep.dependDePourBoucle(p);
};

CAbscisseOrigineRep.prototype.rendValeur = function() {
  return this.abscisseOrigine;
};
CAbscisseOrigineRep.prototype.positionne = function(infoRandom, dimfen) {
  this.existe = this.rep.existe;
  this.abscisseOrigine = this.rep.valAbscisseOrigine;
};
CAbscisseOrigineRep.prototype.confonduAvec = function(p) {
  if (p.className === this.className) {
    return this.rep === p.rep;
  }
  else return false;
};

CAbscisseOrigineRep.prototype.read = function(inps, list){
  CCalculAncetre.prototype.read.call(this, inps, list);
  var ind1 = inps.readInt();
  this.rep = list.get(ind1,"CRepere");
};
CAbscisseOrigineRep.prototype.write = function(oups, list){
  CCalculAncetre.prototype.write.call(this, oups, list);
  var ind1 = list.indexOf(this.rep);
  oups.writeInt(ind1);
};
